/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'AdminSaveErrors';

export const TYPE_KEY_COMPANY = 'COMPANIES';

export const TYPE_KEY_USER = 'USER';
